module.exports = __webpack_public_path__ + "static/media/PinkCard.38ccee83.svg";